import React, { FC } from 'react';
import { useArraySection } from '../../../../useArraySection';
import { Button, Grid } from '@mui/material';
import { SelectCustom } from '../../../../../../../shared/ui/form/select/Select';
import { cabergolineDoseOptions } from '../ThirdStage.helper';
import { DateInput } from '../../../../../../../shared/ui/form/date/Date';
import { GenericIcon } from '../../../../../../../shared/genericIcon/GenericIcon';
import { themeMUI } from '../../../../../../../../theme/theme';
import {
  ITreatmentOfChronicAcromegallyPasireotide,
  ITreatmentOfChronicAcromegalyPasireotideProps
} from './treatmentOfChronicAcromegallyPasireotide.types';
import { initialTreatmentOfChronicAcromegallyPasireotide } from './treatmentOfChronicAcromegallyPasireotide.helper';
import { Input } from '../../../../../../../shared/ui/form/input/Input';
import { useErrorEndDate } from '../../useErrorEndDate';

export const TreatmentOfChronicAcromegallyPasireotide: FC<ITreatmentOfChronicAcromegalyPasireotideProps> = ({
  id,
  initial,
  handleAddTreatmentOfChronicAcromegallyPasireotide,
  editable,
  handleDeleteTreatmentOfChronicAcromegallyPasireotide
}) => {
  const { formik, handleOnClick, disabledAdd } = useArraySection<ITreatmentOfChronicAcromegallyPasireotide>(
    initial ?? initialTreatmentOfChronicAcromegallyPasireotide,
    handleAddTreatmentOfChronicAcromegallyPasireotide
  );

  const errorDate = useErrorEndDate(formik, formik.values.dateStart, formik.values.dateEnd);

  return (
    <>
      {!editable && (
        <Grid
          item
          xs={0.5}
          mt={1}
          mb={editable ? 0 : 1}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          {Number(id) + 1}.
        </Grid>
      )}

      <Grid item xs={2.75} pr={1} mt={1} mb={editable ? 0 : 1}>
        <SelectCustom
          disabled={!editable}
          name={'dose'}
          required={true}
          placeholder={'dawka (mg)'}
          label={'Dawka (mg)'}
          onChange={formik.handleChange}
          value={formik.values.dose}
          options={cabergolineDoseOptions}
        />
      </Grid>
      <Grid item xs={2.75} pr={1} mt={1} mb={editable ? 0 : 1}>
        <Input
          InputLabelProps={{ shrink: true }}
          disabled={!editable}
          name={'frequency'}
          type={'text'}
          onChange={formik.handleChange}
          value={formik.values.frequency}
          placeholder={'częstotliwość (tyg)'}
          label={'Częstotliwość (tyg)'}
        />
      </Grid>
      <Grid item xs={2.75} pr={1} mt={1} mb={editable ? 0 : 1}>
        <DateInput
          disabled={!editable}
          label={'okres - OD'}
          required={true}
          views={['year', 'month']}
          openTo={'year'}
          name={'dateStart'}
          inputFormat={'mm.yyyy'}
          value={formik.values.dateStart}
          onBlur={() => formik.setFieldTouched('dateStart', true)}
          onChange={e => formik.setFieldValue('dateStart', e)}
        />
      </Grid>
      <Grid item xs={2.75} mt={1} mb={editable ? 0 : 1}>
        <DateInput
          disabled={!editable}
          label={'okres - DO'}
          isStill={true}
          required={true}
          views={['year', 'month']}
          openTo={'year'}
          name={'dateEnd'}
          error={errorDate}
          inputFormat={'mm.yyyy'}
          isActive={formik.values.dateEndIsActive}
          setIsActive={() => formik.setFieldValue('dateEndIsActive', !formik.values.dateEndIsActive)}
          value={formik.values.dateEnd}
          onBlur={() => formik.setFieldTouched('dateEnd', true)}
          onChange={e => formik.setFieldValue('dateEnd', e)}
        />
      </Grid>

      {handleDeleteTreatmentOfChronicAcromegallyPasireotide && (
        <Grid item xs={0.5} pl={1} display={'flex'} justifyContent={'center'}>
          <div
            style={{ margin: 'auto' }}
            onClick={() => {
              if (typeof id === 'number') {
                handleDeleteTreatmentOfChronicAcromegallyPasireotide(id);
              }
            }}
          >
            <GenericIcon
              iconName="Close"
              style={{
                color: themeMUI.palette.primary.main,
                cursor: 'pointer',
                verticalAlign: 'middle'
              }}
            />
          </div>
        </Grid>
      )}
      {handleAddTreatmentOfChronicAcromegallyPasireotide && (
        <Grid item xs={1} pl={1} pt={1} display={'flex'} justifyContent={'center'}>
          <Button disabled={disabledAdd || errorDate} variant="contained" color={'primary'} onClick={handleOnClick}>
            ZAPISZ
          </Button>
        </Grid>
      )}
    </>
  );
};
